<template>
    <Modal id="photo-selector-modal">
        <template v-slot:header>
            <div class="modl-header">
                <ModalTabs :tabs="tabs"
                           :selected-tab="selectedTab"
                           @select-tab="selectTab"></ModalTabs>
            </div>
        </template>

        <template v-slot:body>
            <component :is="selectedTab.component"
                       ref="current-tab-component"
                       @cancel="cancel"
                       @resolve="resolve" />
        </template>
    </Modal>
</template>

<script>
import Modal from '@/vue/components/Modals/Modal';
import ModalTabs from '@/vue/components/Modals/ModalTabs';
import PhotoSelectorFromFileTab from './PhotoSelectorFromFileTab';
import PhotoSelectorFromWebcamTab from './PhotoSelectorFromWebcamTab';
import { ModalPropsMixin } from '@/vue/mixins/ModalPropsMixin';
import { TabbedModalMixin } from '@/vue/mixins/TabbedModalMixin';

export default {
    components: {
        Modal,
        ModalTabs,
        PhotoSelectorFromFileTab,
        PhotoSelectorFromWebcamTab,
    },

    mixins: [
        ModalPropsMixin,
        TabbedModalMixin,
    ],

    data() {
        return {
            tabs: [
                {
                    name: 'camera',
                    icon: 'fa-camera',
                    label: 'PHOTO_SELECTOR.WEBCAM_TAB_NAME',
                    component: 'PhotoSelectorFromWebcamTab',
                },
                {
                    name: 'file',
                    icon: 'fa-file-image',
                    label: 'PHOTO_SELECTOR.FILE_TAB_NAME',
                    component: 'PhotoSelectorFromFileTab',
                },
            ],
        };
    },
};
</script>

<style lang="less">
@import (reference) "../../../less/variables";

#photo-selector-modal {
    .modl {
        width: 640px + (@gutter-width * 2);
    }

    .photo-selector-modal__layout {
        display: flex;
        flex-direction: column;
        // It's annoying to have to specify the max height this way, but it doesn't work
        // nicely being inside a flex container, being scrollable, and being up to 100% height
        // but only if necessary.
        // The height is:
        // 100dvh
        // - padding around a modal
        // - modl-header with tabs height
        // - modl-body padding
        // - modl-footer height
        max-height: ~"calc(100dvh - 30px - 63px - 30px - 79px)";
    }

    .photo-selector-modal__img-preview {
        flex-grow: 1;
        flex-shrink: 1;
        max-width: 100%;
        overflow: auto;
        margin-bottom: @gutter-width;

        img {
            display: block;
            // No width specified on purpose.
            // width: 640px;
            max-width: 100%;
            max-height: 100%;
            margin: 0 auto;
        }
    }

    .photo-selector-modal__btn-section {
        flex-grow: 0;
        flex-shrink: 0;
    }
}
</style>
